// extracted by mini-css-extract-plugin
module.exports = {"container":"EABDScreenContainer_container__CDIl_","fadeIn":"EABDScreenContainer_fadeIn__2yMti","appHorizontalMargin":"EABDScreenContainer_appHorizontalMargin__3PnFb"};